import { HttpService } from "../../../utils/DesigningHttpService.js";
import { readStore, storeMediaReference } from "../storefrontService.ts";

const httpService = new HttpService();

export interface UserProductFavorite {
  productVariantId: number;
  masterProductId: number;
  variantAddressTitle: string;
  slug: string;
  title: string;
  isVisible: boolean;
  fileId?: string | null;
  addedAt: string;
}

export async function getFavorites(): Promise<UserProductFavorite[]> {
  const favorites = await readStore("favorites");
  return favorites.map(function (favorite) {
    return {
      productVariantId: favorite.productVariantId,
      masterProductId: favorite.masterProductId,
      variantAddressTitle: favorite.variantAddressTitle,
      slug: favorite.slug,
      title: favorite.title,
      fileId: storeMediaReference(favorite.thumbnailMediaId),
      addedAt: favorite.addedAt,
      isVisible: favorite.isVisible,
    };
  });
}

export async function addFavorite(productVariantId: number): Promise<void> {
  await httpService.putForData(`/catalog/favorites/variants/${productVariantId}`, { selected: true });
}

export function removeFavorite(productVariantId: number): Promise<void> {
  return httpService.putForData(`/catalog/favorites/variants/${productVariantId}`, { selected: false });
}
